<template>
  <GenericTaskCreationStep
    class="create-task-for-business-dialog"
    v-bind="$props"
    v-on="$listeners"
    :disableNextButton="!taskName || !selectedBusiness"
  >
    <template v-slot:title>Create New Task</template>
    <template>
      <v-text-field
        autofocus
        :counter="120"
        :value="taskName"
        v-on:input="(value) => $emit('updateTaskName', value)"
        label="Task name*"
        required
      />
      <PracticeSearch
        :business="selectedBusiness"
        @onBusinessChanged="
          (business) => $emit('updateSelectedBusiness', business)
        "
        class="width-2"
      />
    </template>
  </GenericTaskCreationStep>
</template>

<style>
.create-task-for-business-dialog {
  width: 400px;
}
</style>

<script>
import GenericTaskCreationStep from './GenericTaskCreationStep.vue';
import PracticeSearch from '@/components/common/PracticeSearch.vue';

export default {
  name: 'CreateNewTaskForBusiness',
  components: {
    GenericTaskCreationStep,
    PracticeSearch
  },
  props: {
    hideBackButton: Boolean,
    taskName: String,
    selectedBusiness: Object
  }
};
</script>
